// extracted by mini-css-extract-plugin
module.exports = {"b1icsqua":"b1icsqua","c7t1m8x":"c7t1m8x"};